// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-card-category-item {\n    padding-left: 0.8em;\n}\n\n.menu-card-category-item,\n.menu-card-product-item {\n    border: 1px solid var(--gray-300);\n    min-height: 3em;\n}\n\n.menu-card-category-item-selected,\n.menu-card-product-item-selected {\n    background-color: var(--gray-200);\n    outline: none;\n}\n\n.menu-card-product-item-colorDisplay {\n    width: 0.8em;\n    height: 0.8em;\n}\n\n.menu-card-category-number {\n    color: var(--gray-600);\n}\n", ""]);
// Exports
module.exports = exports;
